module.exports = __webpack_public_path__ + "static/img/exclamation-triangle.eebc1ea5.svg";